export enum OtpType {
  Email = 'email',
  Authenticator = 'authenticator',
}

export enum OtpRequestStatus {
  Success = 'REQUEST_OTP_SUCCESS',
  AlreadyRequested = 'REQUEST_OTP_FAILED_ALREADY_REQUESTED',
  UserNotFound = 'REQUEST_OTP_FAILED_USER_NOT_FOUND',
  WaitingActivation = 'REQUEST_OTP_FAILED_WAITING_ACTIVATION',
  IntermediaryInvalid = 'OTP_INTERMEDIARY_INVALID',
}

export enum OtpSubmitErrorMessage {
  InvalidOtp = 'Username, password, and/or OTP is invalid.',
  ExpiredToken = 'Invalid username or otp intermediary token',
  ExpiredTokenCode = 'USERNAME_PASSWORD_OTP_INVALID',
  SoftLock = 'SOFT_LOCK',
}

export const OTP_REQUEST_STATUS_MESSAGE: Record<string, { key: string }> = {
  [OtpRequestStatus.Success]: {
    key: 'otp_statusMessage_success',
  },
  [OtpRequestStatus.AlreadyRequested]: {
    key: 'otp_statusMessage_alreadyRequested',
  },
  [OtpRequestStatus.UserNotFound]: {
    key: 'login_statusMessage_notFound',
  },
  [OtpRequestStatus.WaitingActivation]: {
    key: 'login_statusMessage_notActivated',
  },
};
